export default __webpack_public_path__ + "static/media/cg_wide_map.5de0aa91.png";